<template>
  <section>
    <div class="mt-5 mb-3 ml-0 mr-0 text-left">
      <b-card>
        <b-card-text>
          <h3>
            <b-row>
              <b-col class="col-9">
                <b-btn
                  :pressed="myRecipesButtonPressed"
                  @click="showMyRecipes"
                >
                  <font-awesome-icon icon="user-tag" size="lg" class="mr-2" /> My Recipes
                </b-btn>
                <b-btn
                  :pressed="sharedButtonPressed"
                  @click="showSharedRecipes"
                >
                  <font-awesome-icon icon="users" size="lg" class="mr-2" /> Shared Recipes
                </b-btn>
                <b-btn
                  :pressed="publicButtonPressed"
                  @click="showPublicRecipes"
                >
                  <font-awesome-icon icon="globe-europe" size="lg" class="mr-2" /> Public Recipes
                </b-btn>
              </b-col>
              <b-col class="col-3">
                <span class="float-right">
                  <router-link
                    :to="{name: 'recipeAdd'}"
                    class="btn-create"
                  >
                    <img
                      height="32"
                      src="/static/img/ic-feature-create.png"
                    />
                    <span>Create new recipe</span>
                  </router-link>
                </span>
              </b-col>
            </b-row>
          </h3>
        </b-card-text>
        <hr>
        <div v-if="loading" class="spinner pt-1">
          <b-spinner label="Loading..."></b-spinner>
        </div>
        <b-card-text v-if="!loading">
          <div class="mb-3">
            <RecipesList v-bind:recipes="recipes"></RecipesList>
          </div>
          <div class="overflow-auto" v-if="showPagination">
            <b-pagination
              v-model="pagination.currentPage"
              :total-rows="pagination.totalCount"
              :per-page="pagination.pageSize"
              first-text="First"
              prev-text="Prev"
              next-text="Next"
              last-text="Last"
              align="center"
              @input="getRecipes">
            </b-pagination>
          </div>
        </b-card-text>
      </b-card>
    </div>
  </section>
</template>

<script>
import RecipesList from './RecipesList'
import {eventBus} from '../../main'

export default {
  name: 'RecipesSection',
  data () {
    return {
      loading: false,
      chosenType: '',
      myRecipesButtonPressed: true,
      sharedButtonPressed: false,
      publicButtonPressed: false,
      recipes: [],
      pagination: {
        currentPage: 1,
        totalCount: 0,
        pageSize: 9
      }
    }
  },
  props: {
    // 'type': String
  },
  components: {
    RecipesList
  },
  created () {
    this.chosenType = "OWN"
    this.getRecipes()
  },
  computed: {
    showPagination: function () {
      // display or not the pagination bar
      return this.pagination.totalCount > this.pagination.pageSize
    },
    updatedType: function () {
      // display or not the creation btn
      return this.type
    },
    // showTitle: function () {
    //   // get the type of displayed recipes
    //   if (this.type === 'OWN') {
    //     return 'My Recipes'
    //   } else if (this.type === 'SHARE') {
    //     return 'Shared Recipes'
    //   } else if (this.type === 'BOOKMARKED') {
    //     return 'Bookmarked Recipes'
    //   }
    // }
  },
  methods: {
    showMyRecipes(){
      // eventBus.$emit('sendChosenRecipeType', "OWN" )
      this.myRecipesButtonPressed =true
      this.publicButtonPressed =false
      this.sharedButtonPressed =false
      this.chosenType = "OWN"
      this.pagination.currentPage = 1
      this.getRecipes()
    },
    showSharedRecipes(){
      // eventBus.$emit('sendChosenRecipeType', "SHARE" )
      this.myRecipesButtonPressed =false
      this.publicButtonPressed =false
      this.sharedButtonPressed =true
      this.chosenType ="SHARE"
      this.pagination.currentPage = 1
      this.getRecipes()
    },
    showPublicRecipes(){
      // eventBus.$emit('sendChosenRecipeType', "PUBLIC" )
      this.myRecipesButtonPressed =false
      this.publicButtonPressed =true
      this.sharedButtonPressed =false
      this.chosenType ="PUBLIC"
      this.pagination.currentPage = 1
      this.getRecipes()
    },

    initRecipes: function () {
      this.recipes = []
    },
    getRecipes: function () {
      this.initRecipes()
      this.loading = true
      // Fetch a list of recipes
      let params = {
        status: this.chosenType,
        start: this.pagination.pageSize * (this.pagination.currentPage - 1),
        count: this.pagination.pageSize
      }
      // get data
      this.$store.dispatch('getRecipesList', params).then(
        data => {
          this.pagination.totalCount = data.totalCount
          this.initRecipes()
          this.recipes = data.results
          this.loading = false
        })
    }
  }
}
</script>

<style scoped>
  .btn {
    width:200px !important;
    background-color: #545b62;
    border-color: #545b62;
  }

  .btn.btn-secondary.active {
    background-color: #EE861D;
    border-color: #EE861D;
  }

  .btn-create {
    font-size: 14pt;
  }
  .btn-create:hover {
    text-decoration: none;
    padding-right: 6px;
  }

  .spinner {
    display: flex;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/recipes/RecipesSection.vue